import script from "./SimpleTrackPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleTrackPlayer.vue?vue&type=script&setup=true&lang=js"

import "./SimpleTrackPlayer.vue?vue&type=style&index=0&id=219cd9ef&lang=scss"

const __exports__ = script;

export default __exports__